import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { toast } from 'react-toastify';

const getUsernameFromStorage = () => {
  try {
    return JSON.parse(localStorage.getItem('AutoParts'))?.username || '';
  } catch {
    return '';
  }
};

export default function KitchenItemDialog({ open, onClose, item, onSaved }) {
  const isEdit = Boolean(item?.itemid);
  const [form, setForm] = useState({ itemname: '', qty: 1, outdate: '' });

  useEffect(() => {
    if (!open) return;
    setForm({
      itemname: item?.itemname || '',
      qty: item?.qty ?? 1,
      outdate: item?.outdate || '',
    });
  }, [open, item]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const itemname = String(form.itemname || '').trim();
    const qty = parseFloat(form.qty);
    const outdate = form.outdate ? String(form.outdate).trim() : '';

    if (!itemname) return toast.error('Item name is required');
    if (!Number.isFinite(qty) || qty <= 0) return toast.error('Invalid qty');

    try {
      if (isEdit) {
        await axios.put(`https://serverkf.ccsoftwares.com/kitchenitems/${item.itemid}`, {
          itemname,
          qty,
          outdate,
        });
        toast.success('Updated');
      } else {
        const user = getUsernameFromStorage();
        if (!user) return toast.error('User not found in localStorage');

        await axios.post('https://serverkf.ccsoftwares.com/kitchenitems', {
          itemname,
          qty,
          user,
        });
        toast.success('Added');
      }

      onSaved?.();
      onClose?.();
    } catch (e) {
      toast.error(e?.response?.data?.error || 'Request failed');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {isEdit ? 'Edit Kitchen Item' : 'Add Kitchen Item'}
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Item Name"
                name="itemname"
                value={form.itemname}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Qty"
                name="qty"
                type="number"
                inputProps={{ min: 0, step: '0.01' }}
                value={form.qty}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Out Date"
                name="outdate"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={form.outdate || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button variant="contained" onClick={handleSubmit}>
                {isEdit ? 'Update' : 'Add'}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

